import { render } from "./tenantlicenseModel.vue?vue&type=template&id=d5300e1a&scoped=true"
import script from "./tenantLicenseModel.js?vue&type=script&lang=js"
export * from "./tenantLicenseModel.js?vue&type=script&lang=js"

import "./tenantlicenseModel.vue?vue&type=style&index=0&id=d5300e1a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5300e1a"]])

export default __exports__